export default __webpack_public_path__ + "static/uservoice-5317a42228370a412aab9d9e3af69f86.png";